import { useCallback, useMemo } from 'react';
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';
import {
  getUpscCaArticleCmsPath,
  normalizeUpscCaArticleResponse
} from '@api/fetchers/upscCurrentAffairs/caArticles';
import { UpscCurrentAffairsTopicArticle } from '@cont/UpscCurrentAffairs/upscCurrentAffairsTopicTypes';

export interface UseUpscCurrentAffairsCaArticleReturn {
  article: UpscCurrentAffairsTopicArticle | null;
  isLoading: boolean;
  isError: boolean;
  retry: () => void;
}

const useUpscCurrentAffairsCaArticle = (
  id?: string
): UseUpscCurrentAffairsCaArticleReturn => {
  const parsedId = id || null;

  const { data, isValidating, isError, mutate } = useFetch(
    parsedId ? getUpscCaArticleCmsPath(parsedId) : null,
    { hostType: HOST_TYPE.CMS, useCamelCase: true }
  );

  const article = useMemo(() => normalizeUpscCaArticleResponse(data), [data]);

  const retry = useCallback(() => {
    mutate();
  }, [mutate]);

  return {
    article,
    isLoading: Boolean(parsedId) && !data && !isError && isValidating,
    isError: Boolean(isError),
    retry
  };
};

export default useUpscCurrentAffairsCaArticle;
